import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
  loading: false,
  error: null,
  tableData: [],
  totalCommodities: 0,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
};

const commodityDetailedSlice = createSlice({
  name: "commoditySamplingDetailed",
  initialState,
  reducers: {
    fetchDetailed: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchDetailedSuccess: (state, action) => {
      const { data, page, limit } = action.payload;
      
      state.loading = false;
      state.tableData = data?.data || [];
      state.totalCommodities = data?.totalCommodities || 0;
      state.pagination.currentPage = page || 1;
      state.pagination.pageSize = limit || 10;
      state.pagination.total = data?.totalCommodities || 0;
    },
    fetchDetailedFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.tableData = [];
      state.totalCommodities = 0;
      state.pagination.total = 0;
    },
    setPagination: (state, action) => {
      const { currentPage, pageSize } = action.payload;
      state.pagination.currentPage = currentPage;
      if (pageSize) {
        state.pagination.pageSize = pageSize;
      }
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
      state.pagination.currentPage = 1;
    },
    resetPagination: (state) => {
      state.pagination.currentPage = 1;
      state.pagination.pageSize = 10;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { actions, reducer } = commodityDetailedSlice;
export const sliceKey = "commoditySamplingDetailed";